'use strict';

angular.module('shiftTraderApp')
    .directive('saMiniDayView', function () {
      return {
        templateUrl: 'views/directives/saMiniDayView.html',
        restrict: 'A',
        scope: {
          allDepartments: '=',
          allShiftsAndWorkPeriods: '=',
          currentDate: '=',
          currentShift: '='
        },
        link: function postLink(scope, element, attrs, ctrl) {

          scope.state = {
            initialized: false
          };

          scope.verticalLines = [
            {
              percent: 0,
              label: '12a'
            },
            {
              percent: 6 / 30.0,
              label: '6a'
            },
            {
              percent: 12 / 30.0,
              label: '12p'
            },
            {
              percent: 18 / 30.0,
              label: '6p'
            },
            {
              percent: 24 / 30.0,
              label: '12a'
            },
            {
              percent: 30 / 30.0,
              label: '6a'
            }
          ];


          function getUniqueId(obj) {
            var str = '';

            if (obj._type === 'workPeriod') {
              str += 'wp-' + obj.id + '-' + obj._dismissed + '-' + obj.active + '-' + (obj.user ? obj.user.id : 'null' );
            } else if (obj._type === 'shift' && obj._workPeriod) {
              str += 'shift-wp-' + obj.id + '-' + obj._workPeriod.id + '-' + obj._dismissed + '-' + (obj._workPeriod.user ? obj._workPeriod.user.id : 'null' );
            } else if (obj._type === 'shift' && !obj._workPeriod) {
              str += 'shift-' + obj.id + '-' + obj._dismissed;
            }

            return str;
          }

          var initAllShiftsAndWorkPeriods = function() {
            var isDark = false;

            scope.departments = _.cloneDeep(scope.allDepartments);
            scope.shiftsByPositionId = {};
            _.each(scope.departments, function(dept) {
              _.each(dept.positions, function(pos) {
                scope.shiftsByPositionId[pos.id] = _.where(scope.allShiftsAndWorkPeriods, function(s) {
                  s._compId = getUniqueId(s);
                  return s.position_id === pos.id;
                });

                pos._hasItemsToFill = (scope.shiftsByPositionId[pos.id].length > 0);
                if (pos._hasItemsToFill) {
                  pos._isDark = isDark;
                  isDark = !isDark;
                }
              });

              dept._hasItemsToFill = _.any(dept.positions, '_hasItemsToFill');
            });
          };

          initAllShiftsAndWorkPeriods();


          function onCurrentShiftChange(newVal, oldVal) {
              if (newVal !== oldVal) {
                initAllShiftsAndWorkPeriods();

                // directly add/remove classes so we don't have to send a message to each saMiniDayViewShift and re-render each
                $(element).find('.sa_mini_day_view_shift.selected').removeClass('selected shift_animate_bg');

                if (scope.currentShift) {
                  $(element).find('#sa-mini-day-view-' + scope.currentShift._type + '-' + scope.currentShift.id).addClass('selected shift_animate_bg');
                }
              }
          }

          scope.$on('sa:saMiniDayView:currentShiftChanged', function(event, currentShift) {
            var oldShiftId = scope.currentShift && scope.currentShift.id;
            scope.currentShift = currentShift;

            onCurrentShiftChange(scope.currentShift.id, oldShiftId);
          });

          scope.$watch('currentShift.id', function(newVal, oldVal) {
            onCurrentShiftChange(newVal, oldVal);
          });

        },
        controller: ['$scope', function($scope) {
          this.getCurrentDate = function() {
            return $scope.currentDate;
          };

          this.getCurrentObj = function() {
            return $scope.currentShift;
          };

          this.selectShiftOrWorkPeriod = function(typeOfObj, objId) {
            console.log('saMiniDayView:objectSelected broadcasting');
            $scope.$emit('saMiniDayView:objectSelected', {type: typeOfObj, id: objId});
          };
        }]
      };
    });
